module.exports = __webpack_public_path__ + "static/lights23-dde6e27ea7489b72af9e10e4e652d192.jpg";